module.exports = __webpack_public_path__ + "assets/e75a6070837e4d8a867ff1be7e1e7e0c.mp4";